<template>
    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-4 col-xs-4 col-sp-4 icon-w ApColumn">
        <div class="userinfo-selector links dropdown js-dropdown popup-over hidden-xl-up">
            <!-- <a href="javascript:void(0)" data-toggle="dropdown" class="popup-title icon" title="Account">
                <i class="fal fa-user-cog"></i>
            </a> -->
            <ul class="popup-content dropdown-menu user-info">
                <li>
                    <a class="signin leo-quicklogin" data-enable-sociallogin="enable" data-type="popup"
                        data-layout="login" href="javascript:void(0)" title="Log in to your customer account"
                        rel="nofollow">
                        <span>Sign in</span>
                    </a>
                </li>
                <li>
                    <a class="register leo-quicklogin" data-enable-sociallogin="enable" data-type="popup"
                        data-layout="register" href="javascript:void(0)" title="Log in to your customer account"
                        rel="nofollow">
                        <span>Register</span>
                    </a>
                </li>
                <li>
                    <a class="myacount dropdown-item"
                        href=""
                        title="My account" rel="nofollow">
                        <span>My
                            account</span>
                    </a>
                </li>
                <li>
                    <a class="ap-btn-wishlist dropdown-item"
                        href=""
                        title="Wishlist" rel="nofollow">
                        <span>Wishlist</span>
                        <span class="ap-total-wishlist ap-total"></span>
                    </a>
                </li>
                <li>
                    <a class="ap-btn-compare dropdown-item"
                        href=""
                        title="Compare" rel="nofollow">
                        <span>Compare</span>
                        <span class="ap-total-compare ap-total"></span>
                    </a>
                </li>
                <li>
                    <a class="checkout dropdown-item"
                        href="" title="Checkout"
                        rel="nofollow">
                        <span>Checkout</span>
                    </a>
                </li>
            </ul>
        </div>
        <!-- <div class="information float-xs-left float-md-left hidden-lg-down">
            <a
                class="login btn-login popup-title"
                href="https://demo74.leotheme.com/prestashop/leo_stationero_demo/en/my-account"
                title="Log in to your customer account"
                rel="nofollow"
            >
                <span>Login</span> </a
            ><span class="navigation-pipe"
                >/</span
            >
            <a
                href="https://demo74.leotheme.com/prestashop/leo_stationero_demo/en/login?create_account=1"
                title="Register account"
                class="register btn-login popup-title"
                rel="nofollow"
                >Register</a
            >
        </div> -->
        <!-- <a class="ap-btn-wishlist t ap-wishlist hidden-md-down"
            href="//demo74.leotheme.com/prestashop/leo_stationero_demo/en/module/leofeature/mywishlist" title="Wishlist"
            rel="nofollow">
            <span class="icon"><i class="fal fa-heart"></i></span>
            <span class="ap-total-wishlist ap-total"></span>
        </a> -->

        <div id="_desktop_cart">
            <div class="blockcart cart-preview inactive cursor-pointer" @click="showMobileCart">
                <div class="header">
                    <span class="icon">
                        <!-- <svg>
                            <use xlink:href="#shopping-cart"></use>
                        </svg> -->
                        <i class="fal fa-shopping-cart"></i>
                    </span>
                    <span class="cart-products-count" v-if="cartStore.quantity">{{ cartStore.quantity }}</span>
                </div>
            </div>
            <CartDropdown />
        </div>
    </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { useRouter } from "vue-router";
import CartDropdown from "../../cart/CartDropdown.vue";
import { useCartStore } from "@/stores/cart";
import { useAuthStore } from "@/stores/auth-store";
import { useWishlistStore } from "@/stores/wishlist-store";

const router = useRouter();
const cartStore = useCartStore();
const authStore = useAuthStore();
const wishlistStore = useWishlistStore();

const cartVisibility = ref(false);
const currencyList = ref(false);
const accountList = ref(false);
const signInModalVisibility = ref(false);
const signUpModalVisibility = ref(false);
const isActive = ref(false);
const emit = defineEmits(["hide-nav"]);
const modalTab = "signIn";

const accountArray = [
    {
        title: "Profile",
        img: "fa-user",
        path: "profile",
    },
    {
        title: "Sign Out",
        img: "fa-power-off",
    },
];

const showCart = async () => {
    cartVisibility.value = !cartVisibility.value;
    isActive.value = true;
};
const openSignUp = () => {
    signUpModalVisibility.value = true;
    signInModalVisibility.value = false;
};
const openSignIn = () => {
    signUpModalVisibility.value = false;
    signInModalVisibility.value = true;
};

const goToOutletPage = () => {
    router.push({
        name: "outlets",
    });
};
const onAccountClick = (item) => {
    if (item.path && item.path == "profile") {
        router.push({
            name: "profile",
        });
    } else {
        onSignOut();
    }
    accountList.value = false;
};

const showAccount = () => {
    if (authStore.currentUser != null) {
        accountList.value = !accountList.value;
    } else {
        signInModalVisibility.value = true;
    }
};

const onSignOut = async () => {
    await authStore.signOut();
    router.push({
        name: "index",
    });
};
const myAccount = computed(() => {
    let title = "";
    if (authStore.currentUser != null) {
        title = authStore.profile.name.toLowerCase();
    } else {
        title = "My Account";
    }
    return title;
});

const isAuthenticated = computed(() => {
    let ac = false;
    if (authStore.currentUser != null) {
        ac = true;
    }
    return ac;
});

const showFavorite = () => {
    if (isAuthenticated.value) {
        router.push({
            name: "profile",
            query: {
                tab: "wishlist",
            },
        });
    } else signInModalVisibility.value = true;
};

const onOutsideClick = () => {
    currencyList.value = false;
    accountList.value = false;
};

const showMobileCart = async () => {
    if (window.innerWidth < 991) {
        router.push({ name: "cart" }); // replace "cart" with your actual cart route name
    } else {
        cartVisibility.value = !cartVisibility.value;
        isActive.value = true;
    }
};
</script>

<style lang="scss">
.flag-list {
    display: none;
    max-height: 300px;
    border-radius: 5px;
    box-shadow: 0 0 0 1px rgba(68, 68, 68, 0.11);
    box-sizing: border-box;
    opacity: 0;
    overflow: inherit;
    padding: 0;
    position: absolute;
    top: 45px;
    left: -15px;
    transform-origin: 50% 0;
    transform: scale(0.75) translateY(-21px);
    z-index: 3026;
    background: #fff;
}

.flag-list:before {
    content: "";
    position: absolute;
    border-color: rgba(194, 225, 245, 0);
    border: solid transparent;
    border-bottom-color: white;
    border-width: 11px;
    margin-left: -10px;
    top: -21px;
    right: 40%;
    z-index: 1;
}

.flag-list:after {
    content: "";
    position: absolute;
    right: 40%;
    top: -21px;
    width: 0;
    height: 0;
    border: solid transparent;
    border-width: 10px;
    border-bottom-color: #2b1a41;
    z-index: 0;
}

.list-click {
    opacity: 1;
    pointer-events: auto;
    transform: scale(1) translateY(0);
    max-height: 300px;
    display: block !important;
}

.account-list {
    display: none;
    max-height: 300px;
    width: 300px;
    border-radius: 5px;
    box-shadow: 0 0 0 1px rgba(68, 68, 68, 0.11);
    box-sizing: border-box;
    overflow-y: inherit;
    padding: 15px;
    position: absolute;
    top: 45px;
    right: 0%;
    transform-origin: 50% 0;
    transform: scale(0.75) translateY(-21px);
    z-index: 3026;
    background: #fff;
    border: 1px solid #cacaca;
}

.drop-down-menu:before {
    content: "";
    position: absolute;
    border-color: rgba(194, 225, 245, 0);
    border: solid transparent;
    border-bottom-color: white;
    border-width: 11px;
    margin-left: -10px;
    top: -21px;
    right: 40%;
    z-index: 1;
}

.drop-down-menu:after {
    content: "";
    position: absolute;
    right: 40%;
    top: -21px;
    width: 0;
    height: 0;
    border: solid transparent;
    border-width: 10px;
    border-bottom-color: #2b1a41;
    z-index: 0;
}

.account-list .option:hover {
    color: #F69320;
}

.account-list .option .lower-slide-section span {
    margin-left: 10px;
}

.option {
    opacity: 1 !important;
    display: list-item !important;
    cursor: pointer;
    font-weight: 400;
    line-height: 40px !important;
    list-style: none;
    min-height: 40px;
    outline: none;
    padding-left: 10px;
    padding-right: 40px;
    padding: 10px 20px;
    text-align: left;
    transition: all 0.2s;
    margin-bottom: 0;
    border-bottom: 1px solid #f0f0f0;

    div {
        .bd-flag {
            margin-right: 5px;
        }
    }
}

.option:last-child {
    border-bottom: none;
}
</style>
